import { isEditing } from '@builder.io/sdk-react';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { Button } from 'src/components/common/Button';
import { scrollToTop } from 'src/helpers/utils';
import { useConnectedAction } from 'src/hooks/use-connected-action';
import { useBannerActions } from 'src/hooks/useBannerActions';
import { openAuthModal } from 'src/store/auth-modal/actions';
import { RootState } from 'src/types/store-types';

export enum EnumCtaActions {
  TO_LOGIN = 'TO_LOGIN',
  TO_REGISTRATION = 'TO_REGISTRATION',
  TO_GAME = 'TO_GAME',
  TO_CATEGORY = 'TO_CATEGORY',
  REDIRECT_URL = 'REDIRECT_URL',
}

export const BuilderIoButtonInputs = [
  {
    type: 'string',
    name: 'label',
    defaultValue: 'CTA Label',
    helperText: 'Visible label of button.',
    required: true,
  },
  {
    type: 'enum',
    name: 'cta',
    helperText: 'Actions of button when user click button.',
    defaultValue: EnumCtaActions.TO_LOGIN,
    required: true,
    enum: [
      {
        label: 'Go to login',
        value: EnumCtaActions.TO_LOGIN,
      },
      {
        label: 'Go to registration',
        value: EnumCtaActions.TO_REGISTRATION,
      },
      {
        label: 'Go to game',
        value: EnumCtaActions.TO_GAME,
      },
      {
        label: 'Go to category',
        value: EnumCtaActions.TO_CATEGORY,
      },
      {
        label: 'Redirection url',
        value: EnumCtaActions.REDIRECT_URL,
      },
    ],
  },
  {
    showIf: `options.get("cta") === "${EnumCtaActions.REDIRECT_URL}"`,
    type: 'url',
    name: 'redirectionUrl',
  },
  {
    showIf: `options.get("cta") === "${EnumCtaActions.TO_GAME}"`,
    type: 'number',
    name: 'gameId',
  },
  {
    showIf: `options.get("cta") === "${EnumCtaActions.TO_CATEGORY}"`,
    type: 'string',
    name: 'categoryName',
  },
];

export const BuilderIoButton: FC<{
  label: string;
  cta: EnumCtaActions;
  redirectionUrl?: string;
  gameId?: string;
  categoryName?: string;
}> = ({ label, cta, redirectionUrl, gameId, categoryName }) => {
  const { user } = useSelector((state: RootState) => state.user);
  const _openAuthModal = useConnectedAction(openAuthModal);
  const { loginAction, registrAction, gameAction, categoryAction, externalUrlAction } = useBannerActions();

  const redirect = (): any => {
    if (isEditing()) return;

    if (process.env.REACT_APP_GLOBAL_NEED_LOGIN && !user) {
      return _openAuthModal('login');
    }

    switch (cta) {
      case EnumCtaActions.TO_REGISTRATION:
        registrAction();
        scrollToTop();
        break;
      case EnumCtaActions.TO_LOGIN:
        loginAction();
        break;
      case EnumCtaActions.REDIRECT_URL:
        redirectionUrl && externalUrlAction(redirectionUrl);
        break;
      case EnumCtaActions.TO_GAME:
        gameId && gameAction(gameId);
        break;
      case EnumCtaActions.TO_CATEGORY:
        categoryName && categoryAction(categoryName);
        scrollToTop();
        break;
      default:
        return;
    }
  };

  return (
    <Button type="button" onClick={redirect} size="lg" className="success-filled-btn">
      {label}
    </Button>
  );
};
